import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.1419 19.8958C19.6397 19.3796 19.6159 18.5658 19.0889 18.0783L12.14 11.6494L19.0889 5.22047C19.6159 4.73291 19.6397 3.91917 19.1419 3.40294C18.6442 2.8867 17.8135 2.86345 17.2865 3.35101L9.32733 10.7146C9.0648 10.9575 8.91602 11.2956 8.91602 11.6494C8.91602 12.0031 9.0648 12.3412 9.32733 12.5841L17.2865 19.9477C17.8135 20.4353 18.6442 20.412 19.1419 19.8958Z'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.81299 3C5.08811 3 4.50049 3.57563 4.50049 4.28571L4.50049 19.7143C4.50049 20.4243 5.08811 21 5.81299 21C6.53786 21 7.12549 20.4243 7.12549 19.7143L7.12549 4.28571C7.12549 3.57563 6.53786 3 5.81299 3Z'
            />
        </SvgIcon>
    );
});
